import { render, staticRenderFns } from "./BannerAddOrEdit.vue?vue&type=template&id=1bf0b185&scoped=true&"
import script from "./BannerAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./BannerAddOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0b185",
  null
  
)

export default component.exports